import { render, staticRenderFns } from "./Registrationsystem.vue?vue&type=template&id=9691efae"
import script from "./Registrationsystem.vue?vue&type=script&lang=js"
export * from "./Registrationsystem.vue?vue&type=script&lang=js"
import style0 from "./Registrationsystem.vue?vue&type=style&index=0&id=9691efae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports